"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseButton = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const classnames_1 = tslib_1.__importDefault(require("classnames"));
const react_slot_1 = require("@radix-ui/react-slot");
const base_button_props_js_1 = require("./base-button.props.js");
const index_js_1 = require("../helpers/index.js");
const flex_js_1 = require("./flex.js");
const spinner_js_1 = require("./spinner.js");
const visually_hidden_js_1 = require("./visually-hidden.js");
const BaseButton = React.forwardRef((props, forwardedRef) => {
    const { size = base_button_props_js_1.baseButtonPropDefs.size.default } = props;
    const { className, children, asChild, color, radius, disabled = props.loading, ...baseButtonProps } = (0, index_js_1.extractProps)(props, base_button_props_js_1.baseButtonPropDefs, index_js_1.marginPropDefs);
    const Comp = asChild ? react_slot_1.Slot : 'button';
    return (React.createElement(Comp
    // The `data-disabled` attribute enables correct styles when doing `<Button asChild disabled>`
    , { "data-disabled": disabled || undefined, "data-accent-color": color, "data-radius": radius, ...baseButtonProps, ref: forwardedRef, className: (0, classnames_1.default)('rt-reset', 'rt-BaseButton', className), disabled: disabled }, props.loading ? (React.createElement(React.Fragment, null,
        React.createElement("span", { style: { display: 'contents', visibility: 'hidden' }, "aria-hidden": true }, children),
        React.createElement(visually_hidden_js_1.VisuallyHidden, null, children),
        React.createElement(flex_js_1.Flex, { asChild: true, align: "center", justify: "center", position: "absolute", inset: "0" },
            React.createElement("span", null,
                React.createElement(spinner_js_1.Spinner, { size: (0, index_js_1.mapResponsiveProp)(size, index_js_1.mapButtonSizeToSpinnerSize) }))))) : (children)));
});
exports.BaseButton = BaseButton;
BaseButton.displayName = 'BaseButton';
//# sourceMappingURL=base-button.js.map